import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useUserPermissions } from '../hooks/useUserPermissions';

interface AppraisalsRouteProps {
  children: React.ReactNode;
}

/**
 * AppraisalsRoute component that checks for deliverables.all or deliverables.view permission
 * Redirects unauthorized users to access denied page
 */
export const AppraisalsRoute: React.FC<AppraisalsRouteProps> = ({ children }) => {
  const { hasPermission, isLoading } = useUserPermissions();

  if (isLoading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="50vh"
        gap={2}
      >
        <CircularProgress size={40} />
        <Typography variant="h6" color="text.secondary">
          Verifying permissions...
        </Typography>
      </Box>
    );
  }

  // Check for either deliverables.all or deliverables.view permission
  if (!hasPermission('deliverables.all') && !hasPermission('deliverables.view')) {
    return <Navigate to="/access-denied" replace />;
  }

  return <>{children}</>;
};